export const HitCodes = {
  A: "Consumer requested security freeze on his/her credit file",
  G: "Consumer requested security freeze on his/her credit file",
  "L*": "Consumer requested Equifax lock on his/her credit file",
  "M*": "Consumer requested Equifax lock on his/her credit file",
  I: "Information from consumer inquiry has been identified as potentially fraudulent or misused, therefore the credit report is not available for delivery"
};

export const errorHitCodes = ["A", "G", "L*", "M*", "I"];

export enum ReasonCodes {
  CODE_01 = "01",
  CODE_02 = "02",
  CODE_03 = "03",
  CODE_04 = "04",
  CODE_05 = "05",
  CODE_06 = "06",
  CODE_07 = "07",
  DECEASED = "deceased",
  INSUFFICIENT_DATA = "insufficient_data",
  OUT_OF_RANGE = "out_of_range",
  REQUIREMENTS_NOT_MET = "requirements_not_met",
  CASCADING_MODEL = "cascading_model",
  MISSING_RISK_MODELS = "missing_risk_models",
  COMPLIANCE_FAILURE = "compliance_failure"
}

export const ScoreReasonCodes: Record<ReasonCodes, string> = {
  [ReasonCodes.CODE_01]: "File not scored because subject is deceased",
  [ReasonCodes.CODE_02]:
    "File not scored because subject does not have sufficient data",
  [ReasonCodes.CODE_03]: "Score out of range",
  [ReasonCodes.CODE_04]: "Requirements not met",
  [ReasonCodes.CODE_05]: "Cascading model",
  [ReasonCodes.CODE_06]: "Missing required risk models",
  [ReasonCodes.CODE_07]: "Does not meet compliance requirements",
  [ReasonCodes.DECEASED]: "File not scored because subject is deceased",
  [ReasonCodes.INSUFFICIENT_DATA]:
    "File not scored because subject does not have sufficient data",
  [ReasonCodes.OUT_OF_RANGE]: "Score out of range",
  [ReasonCodes.REQUIREMENTS_NOT_MET]: "Requirements not met",
  [ReasonCodes.CASCADING_MODEL]: "Cascading model",
  [ReasonCodes.MISSING_RISK_MODELS]: "Missing required risk models",
  [ReasonCodes.COMPLIANCE_FAILURE]: "Does not meet compliance requirements"
};
